/**
 *
 * @param props
 * @returns {*}
 */
export const getImageForScreenType = ( props ) => {
    const { image, image_desktop } = props.question;
    const screenType = document.documentElement.clientWidth <= 420 ? 'mob' : 'desk';

    switch ( screenType ) {
        case 'desk': {
            return image_desktop;
        }
        case 'mob': {
            return image;
        }
        default: {
            return image_desktop;
        }
    }
};

/**
 *
 * @param props
 * @returns {*}
 */
export const getImageForScreenTypeTwo = ( props ) => {
    const { image, image_desktop } = props;
    const screenType = document.documentElement.clientWidth <= 420 ? 'mob' : 'desk';

    switch ( screenType ) {
        case 'desk': {
            return image_desktop;
        }
        case 'mob': {
            return image;
        }
        default: {
            return image_desktop;
        }
    }
};